import CriteriaApprovalList from "../../features/CriteriaApprovalList/CriteriaApprovalList";


const CriteriaApproval = () => {
  return (
    <div>
      <CriteriaApprovalList />
    </div>
  );
};

export default CriteriaApproval;
